import * as React from 'react';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export default function DelayingAppearance({loadingProgess}) {
  const [loading, setLoading] = React.useState(false);


  React.useEffect(
    () => () => {
        if(loadingProgess){
      setLoading(true);
        }
        
    },
    [loadingProgess],
  );

  const handleClickLoading = () => {
    setLoading((prevLoading) => !prevLoading);
  };


  return (
    <Box
    sx={{
      position: 'fixed', // Use fixed positioning to center relative to the viewport
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)', // Centering transformation
      zIndex: 1200, // Ensure it's above other content
    }}
  >
      <Box sx={{ height: 40 }}>
        <Fade
          in={loading}
          style={{
            transitionDelay: loading ? '800ms' : '0ms',
          }}
          unmountOnExit
        >
          <CircularProgress />
        </Fade>
      </Box>
    </Box>
  );
}
